module.exports = __webpack_public_path__ + "img/电梯动画15.a709ce38.png";